import styled from 'styled-components'

export const NakedButton = styled.button`
  all: unset;
  cursor: pointer;
`
